import { useQuery } from "react-query";

import { listReviewPage } from "utils/request/review";

export const useReviewPage = (reference_file_uuid, page) => {
    return useQuery("reviewPage", (e) => listReviewPage(reference_file_uuid, page), {
        staleTime: Infinity,
        cacheTime: Infinity,
        retry: false,
    });
};
